import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as fromAuth from '@app/modules/core/reducers/auth.reducer';
import { environment } from '@environments/environment';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from '../services/api/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  token$ = this.store.pipe(select(fromAuth.getToken));
  token;
  constructor(
    public auth: AuthService,
    public store: Store<any>,
    public router: Router
  ) {
    this.token$.subscribe(token => (this.token = token));
  }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if( environment.API_KEY ){
      request = request.clone({
       setHeaders: {
         apiKey: environment.API_KEY
       }
      });
    }

    if (request.url.includes(environment.API)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token}`
        }
      });
    }

    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // success
          }
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              console.log('401, redirecting', request.url);
              return this.router.navigate(['/login']);
            }
          }
        }
      )
    );
  }
}
